angular.
module("dx.webapp.exams").
controller("DxExamsRouteController", function ExamsRouteController(
	$location,
	$scope,
	$timeout,

	DX_EXAMS_STEPS,
	dxApi,
	dxEvent,
	dxExamsFilters,
	dxSearchSortOptions,
	dxLocalize,
	DX_URLS,
	dxScrollIntoView,
	dxAngularConstantHelper
) {
	"use strict";

	var self = this;

	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;

	self.Urls = DX_URLS;
	self.errors = {
		examTemplates: "",
		exams: "",
	};
	self.searchObject = $location.search();

	$scope.$on("$locationChangeSuccess", function updateSearchObject() {
		self.searchObject = $location.search();
		$scope.$broadcast("DxExamsRouteController:resetSearchSortState");

		// This timeout will run when the digest cycle is complete and the possible touched exam has entered the DOM.
		$timeout(function timeout() {
			var element = angular.element(".listEntry_recentlyTouched");

			if (element.length) {
				dxScrollIntoView(angular.element("[ng-view]"), element);
			}
		});
	});

	self.examSteps = [
		{
			i18Header: "Exams.Library",
			i18NoExams: "Exams.Library.NoExams",
			name: DX_EXAMS_STEPS.library,
			items: [],
			itemType: "examTemplates",
			searchSortOptions: dxSearchSortOptions.examTemplates,
			loaded: false,
		},
		{
			i18Header: "Exams.Scheduled",
			i18NoExams: "Exams.Scheduled.NoExams",
			name: DX_EXAMS_STEPS.scheduled,
			items: [],
			itemType: "exams",
			searchSortOptions: dxSearchSortOptions.scheduledExams,
			loaded: false,
		},
		{
			i18Header: "Exams.Ongoing",
			i18NoExams: "Exams.Ongoing.NoExams",
			name: DX_EXAMS_STEPS.ongoing,
			items: [],
			itemType: "exams",
			searchSortOptions: dxSearchSortOptions.ongoingExams,
			loaded: false,
		},
		{
			i18Header: "Exams.Ungraded",
			i18NoExams: "Exams.Ungraded.NoExams",
			name: DX_EXAMS_STEPS.ungraded,
			items: [],
			itemType: "exams",
			searchSortOptions: dxSearchSortOptions.exams,
			loaded: false,
		},
		{
			i18Header: "Exams.Graded",
			i18NoExams: "Exams.Graded.NoExams",
			name: DX_EXAMS_STEPS.graded,
			items: [],
			itemType: "exams",
			searchSortOptions: dxSearchSortOptions.exams,
			loaded: false,
		},
		{
			i18Header: "Exams.Published",
			i18NoExams: "Exams.Published.NoExams",
			name: DX_EXAMS_STEPS.published,
			items: [],
			itemType: "exams",
			searchSortOptions: dxSearchSortOptions.exams,
			loaded: false,
		},
	];

	self.stepEvents = {};
	self.stepEvents[DX_EXAMS_STEPS.library] = DX_EVENT_NAME.PageviewExamsLibrary;
	self.stepEvents[DX_EXAMS_STEPS.scheduled] = DX_EVENT_NAME.PageviewExamsScheduled;
	self.stepEvents[DX_EXAMS_STEPS.ongoing] = DX_EVENT_NAME.PageviewExamsOngoing;
	self.stepEvents[DX_EXAMS_STEPS.ungraded] = DX_EVENT_NAME.PageviewExamsUngraded;
	self.stepEvents[DX_EXAMS_STEPS.graded] = DX_EVENT_NAME.PageviewExamsGraded;
	self.stepEvents[DX_EXAMS_STEPS.published] = DX_EVENT_NAME.PageviewExamsPublished;

	$scope.$watch("vm.searchObject.step", function stepWatch(newVal) {
		var step = newVal ? newVal : DX_EXAMS_STEPS.library;

		if (self.stepEvents.hasOwnProperty(step)) {
			dxEvent.create(self.stepEvents[step]);
		}
	});

	self.isExamsStep = function isExamsStep(stepName) {
		return (self.searchObject.step === stepName) || (!self.searchObject.step && stepName === DX_EXAMS_STEPS.library);
	};

	self.setExamsStep = function setExamsStep(stepName) {
		$location.search("step", stepName);
		if ($location.search().id) {
			$location.search("id", null);
		}
	};

	function examStep(stepName) {
		for (var i = 0; i < self.examSteps.length; i++) {
			if (self.examSteps[i].name === stepName) {
				self.examSteps[i].loaded = true;
				return self.examSteps[i];
			}
		}

		return self.examSteps[0];
	}

	function getExamTemplates() {
		dxApi.v1.examTemplates.get().then(onGetExamTemplatesSuccess, onGetExamTemplatesError);

		function onGetExamTemplatesSuccess(res) {
			examStep(DX_EXAMS_STEPS.library).items = res.data;
		}

		function onGetExamTemplatesError() {
			self.errors.examTemplates = dxLocalize.get("Error.LoadingExams");
		}
	}

	function getExams() {
		dxApi.v1.exams.get().then(onGetExamsSuccess, onGetExamsError);

		function onGetExamsSuccess(res) {
			var exams = res.data;
			examStep(DX_EXAMS_STEPS.scheduled).items = examStep(DX_EXAMS_STEPS.scheduled).items.concat(exams.filter(dxExamsFilters.scheduledExamsFilter));
			examStep(DX_EXAMS_STEPS.ongoing).items = examStep(DX_EXAMS_STEPS.ongoing).items.concat(exams.filter(dxExamsFilters.ongoingExamsFilter));
			examStep(DX_EXAMS_STEPS.ungraded).items = exams.filter(dxExamsFilters.ungradedExamsFilter);
			examStep(DX_EXAMS_STEPS.graded).items = exams.filter(dxExamsFilters.gradedExamsFilter);
			examStep(DX_EXAMS_STEPS.published).items = exams.filter(dxExamsFilters.publishedExamsFilter);
		}

		function onGetExamsError() {
			self.errors.exams = dxLocalize.get("Error.LoadingExams");
		}
	}

	self.removeExamFromList = function removeExamFromList(exam, step) {
		examStep(step).items = examStep(step).items.filter(function remove(e) {
			return e.id !== exam.id;
		});
	};

	self.addExamToList = function addExamToList(exam, step) {
		examStep(step).items.push(exam);
	};

	getExamTemplates();
	getExams();
});
